// Preprod pick: Preprod: PubNub connection and reconnect improvements.
import PubNub from 'pubnub';
import get from 'lodash/get';
import {getKey} from "@utils/storage";
import { LOCALSTORAGE, FEATURES} from "@constants";
import ENV_CONFIG from '@config/environment/index';
import {getPubnubChannelName, handlePubnubData, isUserloggedIn} from "@utils/common";

let pubnub = null;
let pubNubListener = null;

export default (channel, callback, login) => {
    init();
    if (pubnub && FEATURES.is_pubnub_enabled ) {
        subscribe(channel);
        setListener(callback);
        isUserloggedIn() && !login && fetchMessages();
    }
}

const init = () => {
    let userInfo = JSON.parse(getKey(LOCALSTORAGE.USER_INFO)) || {};
    pubnub = new PubNub({
        publishKey: ENV_CONFIG.PUBNUB.PUBLISH_KEY,
        subscribeKey: ENV_CONFIG.PUBNUB.SUBSCRIBE_KEY,
        uuid: get(userInfo,'sId'),
        origin: "tatasky.pubnubapi.com",
    });
};

const subscribe = (channel) => {
    pubnub.unsubscribeAll();
    pubnub.subscribe({
        channels: [channel],
    });
};

const setListener = (callback) => {
    pubNubListener = pubnub.addListener({
        message: function (data,status) {
            callback(data.message);
        },
    });
};

export const removePubNubListener = () => {
    if (!pubnub) {
        pubNubListener = null;
        return;
    }
    pubNubListener && pubnub.removeListener(pubNubListener);
    pubNubListener = null;
    pubnub.unsubscribeAll();
    pubnub = null;
};

export const fetchMessages = () => {
    let channelName = getPubnubChannelName();
    pubnub.fetchMessages({
        channels: [channelName],
        includeUUID: true,
        count: 1,
    }).then(res=> {
        let data = res?.channels?.[channelName]?.[0]?.message;
        data && handlePubnubData(data, 'from history')
    });
}
